export const AI_COMPONENT_EDITOR_DEFAULT_WIDTH = 480;
export const AI_COMPONENT_EDITOR_MIN_WIDTH = 480;
export const AI_COMPONENT_EDITOR_MIN_HEIGHT = 70;
export const AI_COMPONENT_EDITOR_DEFAULT_HEIGHT = 72;
export const AI_COMPONENT_EDITOR_MAX_HEIGHT = 400;
export const AI_COMPONENT_EDITOR_GAP = 4;
